import { Avatar, AvatarProps, forwardRef } from '@bonusly/design-system';
import { UserDetailEntity } from '@bonusly/user-entities';
import { useUser } from '@bonusly/user-queries';

interface UserAvatarBaseProps extends AvatarProps {
	onClick?: () => void;
}
interface UserAvatarPropsWithEntity extends UserAvatarBaseProps {
	userId?: never;
	user: Pick<UserDetailEntity, 'displayName' | 'profilePic'>;
}

interface UserAvatarPropsWithId extends UserAvatarBaseProps {
	userId: string;
	user?: never;
}

type UserAvatarProps = UserAvatarPropsWithEntity | UserAvatarPropsWithId;

export const UserAvatar = forwardRef<UserAvatarProps, 'span'>(({ user, userId, ...rest }, ref) => {
	const { data: userData } = useUser(user ? undefined : userId);

	if (user) {
		return <Avatar name={user.displayName} src={user.profilePic} ref={ref} {...rest} />;
	}

	if (userData) {
		return <Avatar name={userData.displayName} src={userData.profilePic} ref={ref} {...rest} />;
	}

	return null;
});
